<template>
  <div class="total">
    <module-header :title="`${condition.year}年/月度总表`" :desc="`下单时间在${condition.year}年的订单`">
      <div style="display: flex;align-items: center;">
        <div>
          <el-link type="primary" @click="defaultCompareYears">对比去年<i class="el-icon-sort"></i></el-link>
        </div>
        <div style="margin-left: 20px">
          <el-switch v-model="switchCompareYear" size="mini"
                     @change="changeSwitch('year')"/>
          <span :style="{cursor: 'pointer',height:'30px',color:switchCompareMonth?'#000':'#999'}">选择对比年份</span>
        </div>
        <div style="margin-left: 20px">
          <el-switch v-model="switchShowQuarter" size="mini"/>
          <span :style="{cursor: 'pointer',height:'30px',color:switchCompareMonth?'#000':'#999'}">显示季度</span>
        </div>
      </div>
      <div slot="right" style="font-size: 16px;display: flex;align-items: center;">
        <span class="i-handel" @click="refreshData" style="margin-right: 8px;">
          <i slot="right" class="el-icon-refresh" style="margin-right: 5px;"/>
        </span>
        <el-button size="mini" type="primary" plain icon="el-icon-upload2" style="margin-right: 8px;"
                   @click="openSyncDialog" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
        <summary-export-link filename="月度总表" :params="{...{tag: 'summaryMonthly'},...condition}"/>
      </div>

    </module-header>

    <el-dialog title="同步月度总表到飞书多维表格" :visible.sync="dialogSyncVisible" width="760px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        将当前{{ condition.year }}年（1-12月）的月度总表同步到飞书多维表格，按月写入一条记录。<br/>
        「月份」等字段若选择「日期」类型，将按「年份 + 月份」写入日期（取当月 1 号）。
      </div>
      <el-form :model="syncForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="syncForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="数据表 ID">
          <div style="display: flex;align-items: center;">
            <el-input v-model="syncForm.table_id" placeholder="tblxxxxxxxxxx（必填）" clearable style="flex:1"/>
            <el-button style="margin-left: 8px;" size="mini" type="primary" plain icon="el-icon-plus"
                       @click="openCreateTableDialog">新增数据表</el-button>
          </div>
        </el-form-item>
        <el-form-item label="写入模式">
          <el-radio-group v-model="syncForm.mode">
            <el-radio label="append">追加（每次同步新增记录）</el-radio>
            <el-radio label="replace">覆盖（先清空目标表再写入）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="syncForm.fields" size="mini" border>
            <el-table-column label="数据源字段" width="200">
              <template slot-scope="{row}">
                <span>{{ row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="飞书列名" width="220">
              <template slot-scope="{row}">
                <el-input v-model="row.name" size="mini" placeholder="列名"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="110">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="同步" width="70" align="center">
              <template slot-scope="{row}">
                <el-switch v-model="row.enabled" size="mini"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-copy" @click="copySyncFieldsToJson">复制为 JSON</el-button>
            <el-button type="text" icon="el-icon-document-copy" style="color:#409EFF" @click="copySyncFieldsAsBitableJson">复制为飞书字段 JSON</el-button>
            <el-button type="text" icon="el-icon-document-add" @click="syncBatchJsonVisible = !syncBatchJsonVisible">
              批量粘贴 JSON 生成字段
            </el-button>
            <el-input v-if="syncBatchJsonVisible" v-model="syncBatchJson" type="textarea" :rows="4"
                      placeholder='JSON 数组，每次生成多行字段，如 [{"name":"订单金额","type":2,"enabled":true}]（enabled 可选，默认 true）'/>
            <div v-if="syncBatchJsonVisible" style="margin-top: 6px;">
              <el-button size="mini" type="primary" @click="applySyncBatchJson">生成字段</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSyncVisible = false">取 消</el-button>
        <el-button @click="handleSaveSyncConfig">保存为全局默认</el-button>
        <el-button type="primary" :loading="syncLoading" @click="handleSyncMonthly" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增数据表（同步月度总表）" :visible.sync="createTableVisible" width="620px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        在当前多维表格 App 内新建一个数据表，创建成功后会自动把数据表 ID 回填到上方「数据表 ID」。
      </div>
      <el-form :model="createTableForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="createTableForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="表名称">
          <el-input v-model="createTableForm.name" placeholder="数据表名称，如：月度总表" clearable/>
        </el-form-item>
        <el-form-item label="默认视图名">
          <el-input v-model="createTableForm.default_view_name" placeholder="可选，如 表格视图" clearable/>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="createTableForm.fields" size="mini" border>
            <el-table-column label="字段名称">
              <template slot-scope="{row}">
                <el-input v-model="row.field_name" size="mini" placeholder="字段名称"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="150">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="128" align="center">
              <template slot-scope="{row, $index}">
                <el-button type="text" size="mini" @click="copyCreateField($index)">复制</el-button>
                <el-button type="text" size="mini" style="color:#409EFF" @click="pasteCreateField($index)">粘贴</el-button>
                <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeCreateTableField($index)"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-copy" @click="copyCreateFieldsToJson">复制为 JSON</el-button>
            <el-button type="text" icon="el-icon-document-add" @click="createBatchJsonVisible = !createBatchJsonVisible">
              批量粘贴 JSON 生成字段
            </el-button>
            <el-input v-if="createBatchJsonVisible" v-model="createBatchJson" type="textarea" :rows="4"
                      placeholder='JSON 数组，每次生成多行字段，如 [{"field_name":"订单金额","type":2}]'/>
            <div v-if="createBatchJsonVisible" style="margin-top: 6px;">
              <el-button size="mini" type="primary" @click="applyCreateBatchJson">生成字段</el-button>
            </div>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addCreateTableField">添加字段</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createTableVisible = false">取 消</el-button>
        <el-button type="primary" :loading="createTableLoading" @click="handleCreateTable">新增数据表</el-button>
      </span>
    </el-dialog>

    <el-row style="margin-top: 15px" v-for="(year,key) in compareYears" :key="key">
      <summary-year-table :key="keyDom" :year="year" :organization-id="condition.organization_id"
                          :switch-show-quarter="switchShowQuarter"/>
    </el-row>
    <el-divider/>
    <el-row>
      <div id="dataMonthlyChart"/>
    </el-row>
    <el-row style="margin-top: 30px">
      <summary-sale-target-amount :key="keyDom" :year="condition.year" :organization-id="condition.organization_id" />
    </el-row>
    <!--  对比年  -->
    <el-dialog title="对比年" class="compare-dialog" :visible.sync="dialogCompareYear" width="50%"
               :before-close="dialogCompareYearClose">
      <br/>
      <div v-for="(_,index) in compareYears"
           :key="index + 'compareYears'"
           style="margin-bottom: 16px;">
        <el-date-picker :clearable="false" v-model="compareYears[index]" type="year" value-format="yyyy"
                        placeholder="选择年"/>
        <template>
          <el-button @click="compareYears.push('')" style="margin-left: 16px;" icon="el-icon-plus" circle
                     :style="{
                                pointerEvents: index + 1 === compareYears.length ? 'all' : 'none',
                                opacity: index + 1 === compareYears.length ? 1 : 0
                            }">
          </el-button>
          <el-button v-if="compareYears.length > 1"
                     @click="compareYears.splice(index, 1)" style="margin-left: 16px;" type="danger" circle
                     icon="el-icon-delete"
          >
          </el-button>
        </template>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center !important;">
           <el-button type="primary" @click="compareYearData" class="el-button--operation">点击对比数据</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getDashboardSummary, getCompareYearSummary} from "@/api/dashboard";
import {feishuSyncConfig, saveFeishuSyncConfig, feishuSyncMonthly, feishuCreateTable} from "@/api/feishu";
import {copyToClipboard} from "@/utils/security";
import SummaryYearTable from "@/components/summary/SummaryDataMonthly/SummaryYearTable";
import SummarySaleTargetAmount from "@/components/summary/SummaryDataMonthly/SummarySaleTargetAmountTable";
import ModuleHeader from "@/components/summary/ModuleHeader.vue";
import SummaryExportLink from "@/components/summary/ExportLink.vue";

const option = {
  grid: {
    left: '5%',
    right: '4%',
    bottom: '8%',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      }
    }
  },
  legend: {
    left: '10%',
    itemWidth: 15,
    itemHeight: 10,
    data: ['订单量', '订单金额']
  },
  xAxis: {
    axisLine: {
      lineStyle: {
        color: '#B6B6B6',
      }
    },
    data: []
  },
  yAxis: [
    {
      type: 'value',
      name: '万元',
      min: 0,
      axisLabel: {
        formatter: (value) => {
          return Number(value) / 10000
        },
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    },
    {
      type: 'value',
      name: '单',
      min: 0,
      interval: 100,
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: '#B6B6B6'
        }
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: '#B6B6B6',
        }
      },
    }
  ],
  series: [
    {
      name: '订单量',
      type: 'line',
      yAxisIndex: 1,
      data: []
    },
    {
      barWidth: '20',
      name: '订单总额',
      type: 'bar',
      yAxisIndex: 0,
      data: []
    }
  ],
};

let myChart
export default {
  name: "SummaryDataMonthly",
  components: {SummaryExportLink, ModuleHeader, SummaryYearTable, SummarySaleTargetAmount},
  inject: ['condition'],

  data() {
    return {
      dialogCompareMonth: false,
      dialogCompareYear: false,
      switchCompareMonth: false,
      switchCompareYear: false,
      switchShowQuarter: false,
      keyDom: new Date().getTime(),
      option: Object.assign({}, option),
      compareMonths: [''],
      compareYears: [],
      totalData: {total_count: 0, total_money: 0}, //数据汇总
      dialogSyncVisible: false,
      syncLoading: false,
      fieldTypeOptions: [
        {value: 1, label: '文本'},
        {value: 2, label: '数字'},
        {value: 3, label: '单选'},
        {value: 5, label: '日期'},
        {value: 7, label: '复选框'}
      ],
      syncForm: {app_token: '', table_id: '', mode: 'append', fields: []},
      copiedSyncField: null,
      copiedCreateField: null,
      syncBatchJsonVisible: false,
      syncBatchJson: '',
      createBatchJsonVisible: false,
      createBatchJson: '',
      createTableVisible: false,
      createTableLoading: false,
      createTableForm: {app_token: '', name: '', default_view_name: '', fields: []},
    }
  },
  watch: {
    condition: {
      handler: function () {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.compareYears = [this.condition.year + '']
      this.refreshData()
    },
    refreshData() {
      this.keyDom = new Date().getTime()
      this.getChartData()
    },
    getChartData() {
      getDashboardSummary({year: this.condition.year, organization_id: this.condition.organization_id}).then(res => {
        this.data = res.model;
        this.totalData.total_money = res.model.total_money || 0;
        this.totalData.total_count = res.model.total_count || 0;
        const xAxisData = res.model.x_data || [];
        const order_count = res.model.order_count;
        const order_money = res.model.order_money;
        for (let i = 0; i < xAxisData.length; i++) {
          xAxisData[i] += '月';
        }
        myChart = echarts.init(document.getElementById('dataMonthlyChart'));
        this.switchCompareMonth = false;
        this.option.xAxis.data = xAxisData;
        this.option.legend.data = ['订单量', '订单金额'];
        this.option.series = [];
        const count = {
          name: '订单量',
          type: 'line',
          yAxisIndex: 1,
          data: order_count
        };
        const money = {
          name: '订单金额',
          type: 'bar',
          yAxisIndex: 0,
          barWidth: 10,
          data: order_money
        };
        this.option.series.push(count);
        this.option.series.push(money);
        myChart.setOption(this.option, true)
      })
    },
    changeSwitch(type) {
      switch (type) {
        case 'month':
          this.dialogCompareMonth = this.switchCompareMonth;
          this.compareMonths = [this.condition.year + '-' + this.month]; // 默认对比当前选中月份
          if (!this.switchCompareMonth) {
            this.getChartData()
          }
          break;
        case 'year':
          this.dialogCompareYear = this.switchCompareYear;
          this.compareYears = [this.condition.year + '']
          // this.compareYears = [''];
          if (!this.switchCompareYear) {
            this.getChartData()
          }
          break;
      }

    },
    dialogCompareMonthClose() {
      this.switchCompareMonth = false
      this.dialogCompareMonth = false
    },
    dialogCompareYearClose() {
      this.switchCompareYear = false
      this.dialogCompareYear = false
    },
    compareYearData() {
      this.dialogCompareYear = false
      if (!Array.isArray(this.compareYears)) {
        this.switchCompareYear = false
        return;
      }
      this.compareYears = this.compareYears.filter(item => item)            // 过滤空字符串
      if (this.compareYears.length < 1) {
        this.compareYears.push('');
        this.switchCompareYear = false
        return;
      }
      getCompareYearSummary({times: this.compareYears}).then(res => {
        this.keyDom = new Date().getTime()
        this.renderCompareChart(res.model.x_data, res.model.data)
        this.switchCompareMonth = false
      })
    },
    /**
     * 对比后重新渲染 eChart
     * @param x_data
     * @param data
     */
    renderCompareChart(x_data, data) {
      this.option.xAxis.data = x_data;
      let legendData = []
      this.option.series = []
      for (let i = 0; i < data.length; i++) {
        const obj = data[i];
        const count = {
          name: obj.time + ' 订单量 ',
          type: 'line',
          yAxisIndex: 1,
          data: obj.order_count || []
        };
        const money = {
          barWidth: 10,
          name: obj.time + ' 订单金额',
          type: 'bar',
          yAxisIndex: 0,
          data: obj.order_money || []
        };
        legendData.push(obj.time + ' 订单量 ');
        legendData.push(obj.time + ' 订单金额');
        this.option.series.push(count);
        this.option.series.push(money);
      }
      this.option.legend.data = legendData
      myChart.setOption(this.option, true);
    },
    defaultCompareYears() {
      let currentYear = this.condition.year
      let lastYear = currentYear - 1
      this.compareYears = [currentYear + '', lastYear + '']
    },
    openSyncDialog() {
      this.dialogSyncVisible = true
      // 拉取全局默认同步配置填充
      feishuSyncConfig().then(res => {
        if (res && res.success) {
          this.syncForm.app_token = res.data.app_token || ''
          this.syncForm.table_id = res.data.table_id || ''
          this.syncForm.mode = res.data.mode || 'append'
          this.syncForm.fields = (res.data.fields || []).map(f => ({...f}))
        }
      })
    },
    buildSyncPayload() {
      return {
        app_token: this.syncForm.app_token,
        table_id: this.syncForm.table_id,
        mode: this.syncForm.mode,
        fields: (this.syncForm.fields || []).map(f => ({
          field: f.field,
          name: f.name,
          type: f.type,
          enabled: !!f.enabled
        }))
      }
    },
    handleSaveSyncConfig() {
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      saveFeishuSyncConfig(this.buildSyncPayload()).then(res => {
        if (res && res.success) {
          this.$message.success('已保存为全局默认同步配置')
        }
      })
    },
    handleSyncMonthly() {
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      this.syncLoading = true
      const payload = this.buildSyncPayload()
      payload.year = this.condition.year
      payload.organization_id = this.condition.organization_id || ''
      feishuSyncMonthly(payload).then(res => {
        this.syncLoading = false
        if (res && res.success) {
          this.$message.success(`同步成功：共 ${res.data.records || 0} 条月度数据，新增 ${res.data.created || 0} 条记录`)
          this.dialogSyncVisible = false
        }
      }).catch(() => {
        this.syncLoading = false
      })
    },
    openCreateTableDialog() {
      // 用当前填写的 app_token 预填，免去重复输入
      this.createTableForm.app_token = this.syncForm.app_token || ''
      this.createTableVisible = true
    },
    // 主同步弹窗：复制某一行的字段配置到剪贴板
    copySyncField(index) {
      this.copiedSyncField = {...this.syncForm.fields[index]}
      this.$message.success('已复制该字段配置')
    },
    // 主同步弹窗：把剪贴板字段配置粘贴到当前行之后新增一行
    pasteSyncField(index) {
      if (!this.copiedSyncField) {
        this.$message.warning('请先复制某一行的字段配置')
        return
      }
      this.syncForm.fields.splice(index + 1, 0, {...this.copiedSyncField})
    },
    // 新增数据表弹窗：复制某一行的字段配置到剪贴板
    copyCreateField(index) {
      this.copiedCreateField = {...this.createTableForm.fields[index]}
      this.$message.success('已复制该字段配置')
    },
    // 新增数据表弹窗：把剪贴板字段配置粘贴到当前行之后新增一行
    pasteCreateField(index) {
      if (!this.copiedCreateField) {
        this.$message.warning('请先复制某一行的字段配置')
        return
      }
      this.createTableForm.fields.splice(index + 1, 0, {...this.copiedCreateField})
    },
    // 解析批量粘贴的 JSON（必须是数组）
    parseBatchFieldJson(str) {
      if (!str || !str.trim()) {
        this.$message.warning('请先粘贴 JSON 内容')
        return null
      }
      let parsed
      try {
        parsed = JSON.parse(str)
      } catch (e) {
        this.$message.error('不是合法的 JSON，请检查格式')
        return null
      }
      if (!Array.isArray(parsed)) {
        this.$message.error('需为 JSON 数组，如 [{...},{...}]')
        return null
      }
      return parsed
    },
    // 主同步弹窗：批量 JSON 生成字段（一次性追加多行）
    applySyncBatchJson() {
      const parsed = this.parseBatchFieldJson(this.syncBatchJson)
      if (!parsed) {
        return
      }
      const rows = parsed.map(item => ({
        field: item.field || '',
        label: item.label || item.name || item.field || '',
        name: item.name || '',
        type: item.type || 1,
        enabled: item.enabled !== undefined ? !!item.enabled : true
      }))
      this.syncForm.fields.push(...rows)
      this.$message.success(`已批量生成 ${rows.length} 个字段`)
      this.syncBatchJson = ''
      this.syncBatchJsonVisible = false
    },
    // 新增数据表弹窗：批量 JSON 生成字段（一次性追加多行）
    applyCreateBatchJson() {
      const parsed = this.parseBatchFieldJson(this.createBatchJson)
      if (!parsed) {
        return
      }
      const rows = parsed.map(item => ({
        field_name: item.field_name || '',
        type: item.type || 1
      }))
      this.createTableForm.fields.push(...rows)
      this.$message.success(`已批量生成 ${rows.length} 个字段`)
      this.createBatchJson = ''
      this.createBatchJsonVisible = false
    },
    // 主同步弹窗：把当前全部字段批量导出为 JSON 字符串并复制到剪贴板
    copySyncFieldsToJson() {
      const rows = (this.syncForm.fields || []).map(item => ({
        field: item.field || '',
        label: item.label || item.name || item.field || '',
        name: item.name || '',
        type: item.type || 1,
        enabled: item.enabled !== undefined ? !!item.enabled : true
      }))
      if (!rows.length) {
        this.$message.warning('暂无自定义字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个字段的 JSON 到剪贴板`)
      })
    },
    // 主同步弹窗：把当前已启用的同步字段复制为「飞书多维表格自定义字段」JSON（[{field_name,type}]，供新增数据表建列/批量粘贴生成字段）
    copySyncFieldsAsBitableJson() {
      const rows = (this.syncForm.fields || [])
        .filter(item => item.enabled !== false && (item.name || '').trim())
        .map(item => ({
          field_name: (item.name || '').trim(),
          type: item.type || 1
        }))
      if (!rows.length) {
        this.$message.warning('暂无已启用的同步字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个飞书多维表格字段的 JSON 到剪贴板`)
      })
    },
    // 新增数据表弹窗：把当前全部字段批量导出为 JSON 字符串并复制到剪贴板
    copyCreateFieldsToJson() {
      const rows = (this.createTableForm.fields || []).map(item => ({
        field_name: item.field_name || '',
        type: item.type || 1
      }))
      if (!rows.length) {
        this.$message.warning('暂无自定义字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个字段的 JSON 到剪贴板`)
      })
    },
    addCreateTableField() {
      this.createTableForm.fields.push({field_name: '', type: 1})
    },
    removeCreateTableField(index) {
      this.createTableForm.fields.splice(index, 1)
    },
    handleCreateTable() {
      if (!this.createTableForm.app_token) {
        this.$message.warning('请填写多维表格 App Token')
        return
      }
      if (!this.createTableForm.name) {
        this.$message.warning('请填写表名称')
        return
      }
      const payload = {
        app_token: this.createTableForm.app_token,
        name: this.createTableForm.name,
        default_view_name: this.createTableForm.default_view_name,
        fields: this.createTableForm.fields.filter(item =>
          item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
      }
      this.createTableLoading = true
      feishuCreateTable(payload).then(res => {
        this.createTableLoading = false
        if (res && res.success) {
          this.createTableVisible = false
          // 新增成功，把新数据表 ID 回填到同步表单
          if (res.data && res.data.table_id) {
            this.syncForm.table_id = res.data.table_id
          }
          this.$message.success('新增数据表成功，已回填数据表 ID')
        }
      }).catch(() => {
        this.createTableLoading = false
      })
    },
  }
}
</script>
<style scoped>

.total {
  height: auto;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.dashboard-table thead tr, .dashboard-table thead th {
  background-color: #fff !important;
}

.dashboard-table thead th {
  font-weight: 900;
  font-size: 16px;
}
</style>

<style>

#dataMonthlyChart {
  width: calc((100vw - 0px - 75px) * 0.95);
  height: calc(380px - 48px - 50px);
}

.order-dashboard-table thead tr, .order-dashboard-table thead th {
  background-color: #fff !important;
  color: #313337 !important;
}
</style>
